import React, { useEffect, useState } from 'react';
import { Select, Button, Spin, Row, Col, Form } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import AddSiteModal from './AddSiteModal';
import AddContactModal from './AddContactModal';
import { getCustomerContactsRequest, getCustomerSitesRequest } from '../../../core/account/accountActions';
import './style.scss';

const DeliveryDetails = () => {
    const dispatch = useDispatch();
    const {
        customerSites,
        isFetchingCustomerSites,
        customerContacts,
        isFetchingCustomerContacts,
    } = useSelector(state => state.account);
    const [showAddSiteModal, setShowAddSiteModal] = useState(false);
    const [showAddContactModal, setShowAddContactModal] = useState(false);
    const [selectedSite, setSelectedSite] = useState(null);
    const [selectedContact, setSelectedContact] = useState(null);
    const [selectedCCContact, setSelectedCCContact] = useState(null);
    const [editingContact, setEditingContact] = useState(null);
    const [editingTarget, setEditingTarget] = useState(null);

    const onChangeSite = (val) => {
        // 20241013 YUANKUI TRY TO FIX TH-37
        //          When val is an object, display it.
        if (val && typeof val === 'object') {
            setSelectedSite(val);
            document.getElementById('address_id').value = val.ADR_ID;
        } else {
            // When val is not an object, use it as ADR_ID to find the site object and display.
            setSelectedSite(customerSites.find(site => site.ADR_ID === val));
            document.getElementById('address_id').value = val;
        }
    };

    const onChangeContact = (val) => {
        let contact;
        // 20241015 YUANKUI TRY TO FIX TH-37
        //          When val is an object, display it.
        if (val && typeof val === 'object') {
            contact = val;
        } else if (val) {
            // When val is not an object, use it as id to find the contact object and display.
            contact = customerContacts.find(c => c.id === val);
        }
        setSelectedContact(contact);
        document.getElementById('site_user_id').value = contact?.id;

        if (contact && !contact.mobileNumber) {
            // Some contact's email looks like: adam rozycki <a.rozycki@craft-interior.co.uk>
            // Can't pass the email validation, so we need to extract the email from the string.
            // eslint-disable-next-line prefer-destructuring
            if (contact?.email) contact.email = contact.email.match(/[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}/)[0];
            setEditingContact(contact);
            setEditingTarget('contact');
            setShowAddContactModal(true);
        } else {
            setEditingContact(undefined);
            setEditingTarget(undefined);
        }
    };

    const onChangeCCContact = (val) => {
        // 241227 YUANKUI: THX-117: Allow an order confirmation to be CC'd to another customers contact.
        let contact;
        if (val && typeof val === 'object') {
            contact = val;
        } else if (val) {
            // When val is not an object, use it as id to find the contact object and display.
            contact = customerContacts.find(c => c.id === val);
        }
        setSelectedCCContact(contact);
        document.getElementById('cc_user_id').value = contact?.id;

        if (contact && !contact.mobileNumber) {
            // Some contact's email looks like: adam rozycki <a.rozycki@craft-interior.co.uk>
            // Can't pass the email validation, so we need to extract the email from the string.
            // eslint-disable-next-line prefer-destructuring
            if (contact?.email) contact.email = contact.email.match(/[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}/)[0];
            setEditingContact(contact);
            setEditingTarget('ccContact');
            setShowAddContactModal(true);
        } else {
            setEditingContact(undefined);
            setEditingTarget(undefined);
        }
    };

    const onContactActionComplete = (val) => {
        if (editingTarget === 'ccContact') onChangeCCContact(val);
        else if (editingTarget === 'contact') onChangeContact(val);
    };

    // 250410 YUANKUI: FIX THX-157: when clicking the back button, the contact should be reset to “Select a contact“ instead of staying at the contact with no mobile.
    useEffect(() => {
        // back button clicked, showAddContactModal will be false
        if (!showAddContactModal && editingContact && !editingContact.mobileNumber) {
            if (document.getElementById('site_user_id') && document.getElementById('site_user_id').value === editingContact.id) {
                document.getElementById('site_user_id').value = '';
                setSelectedContact(undefined);
            } else if (document.getElementById('cc_user_id') && document.getElementById('cc_user_id').value === editingContact.id) {
                document.getElementById('cc_user_id').value = '';
                setSelectedCCContact(undefined);
            }
        }
    }, [showAddContactModal]);

    useEffect(() => {
        dispatch(getCustomerSitesRequest());
        dispatch(getCustomerContactsRequest());
    }, []);

    return (
        <div className="delivery-details-container">
            {!isFetchingCustomerSites ? (
                <>
                    <Row>
                        <Col span={9}>Site</Col>
                        <Col span={13}>
                            <Form.Item required>
                                <Select
                                    allowClear
                                    showSearch
                                    filterOption={(input, option) => (Object.values(option).join(',')).toLowerCase().includes(input.toLowerCase())}
                                    key={selectedSite ? selectedSite.ADR_ID : undefined}
                                    value={selectedSite ? selectedSite.ADR_ID : undefined}
                                    defaultValue="Select a site.."
                                    style={{ width: '100%' }}
                                    onChange={(val) => onChangeSite(val)}>
                                    {customerSites.map(site => (
                                        <Select.Option value={site.ADR_ID}>{site.ADR_NAME}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={2}>
                            <Button onClick={() => setShowAddSiteModal(true)}>+</Button>
                            <AddSiteModal setShowModal={setShowAddSiteModal} showModal={showAddSiteModal} onActionComplete={onChangeSite} />
                        </Col>
                    </Row>
                    {selectedSite && (
                        <Row>
                            <Col span={24} className="selected-site-table-container">
                                <table className="selected-site-table">
                                    <tr>
                                        <th>ADDRESS LINE 1</th>
                                        <td>{selectedSite.ADR_LINE1}</td>
                                    </tr>
                                    <tr>
                                        <th>ADDRESS LINE 2</th>
                                        <td>{selectedSite.ADR_LINE2}</td>
                                    </tr>
                                    <tr>
                                        <th>TOWN/CITY</th>
                                        <td>{selectedSite.ADR_TOWN}</td>
                                    </tr>
                                    <tr>
                                        <th>COUNTY</th>
                                        <td>{selectedSite.ADR_COUNTY}</td>
                                    </tr>
                                    <tr>
                                        <th>POSTCODE</th>
                                        <td>{selectedSite.ADR_POSTCODE}</td>
                                    </tr>
                                </table>
                            </Col>
                        </Row>
                    )}
                </>
            ) : <Spin />}
            {!isFetchingCustomerContacts ? (
                <Row>
                    <Col span={9}>Contact</Col>
                    <Col span={13}>
                        <Form.Item required>
                            <Select
                                allowClear
                                showSearch
                                filterOption={(input, option) => (Object.values(option).join(',')).toLowerCase().includes(input.toLowerCase())}
                                key={selectedContact ? selectedContact.id : undefined}
                                value={selectedContact ? selectedContact.id : undefined}
                                defaultValue="Select a contact.."
                                style={{ width: '100%' }}
                                onChange={(val) => onChangeContact(val)}>
                                {customerContacts.map(contact => (
                                    <Select.Option value={contact.id}>{contact.firstName} {contact.lastName}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={2}>
                        <Button onClick={() => { setEditingContact(undefined); setShowAddContactModal(true); }}>+</Button>
                        <AddContactModal setShowModal={setShowAddContactModal} showModal={(showAddContactModal)} contact={editingContact} onActionComplete={onContactActionComplete} />
                    </Col>
                </Row>
            ) : <Spin />}
            {!isFetchingCustomerContacts ? (
                <Row>
                    <Col span={9}>CC Contact</Col>
                    <Col span={13}>
                        <Form.Item>
                            <Select
                                allowClear
                                showSearch
                                filterOption={(input, option) => (Object.values(option).join(',')).toLowerCase().includes(input.toLowerCase())}
                                key={selectedCCContact ? selectedCCContact.id : undefined}
                                value={selectedCCContact ? selectedCCContact.id : undefined}
                                defaultValue="Select a CC contact.."
                                style={{ width: '100%' }}
                                onChange={(val) => onChangeCCContact(val)}>
                                {customerContacts.map(contact => (
                                    <Select.Option value={contact.id}>{contact.firstName} {contact.lastName}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={2}>
                        <Button onClick={() => { setEditingContact(undefined); setShowAddContactModal(true); }}>+</Button>
                    </Col>
                </Row>
            ) : <Spin className="invisible" />}
        </div>
    );
};

export default DeliveryDetails;
